<template>
  <div class="box gray-box gray-box-bg">
    <div class="box-body inner-title">
      <el-row class="box-header">
        <el-col :span="18">
          <h3>任务总计</h3>
        </el-col>
        <!--<el-col :span="6" class="text-right">
          <el-button type="text" @click="dialogFormVisible = true">修改</el-button>
        </el-col>-->
      </el-row>
      <div class="content">
        <div style="margin-bottom:15px;">
          <el-row class="total-line">
            <el-col :span="12">
              商品金额
            </el-col>
            <el-col :span="12" class="text-right">
              {{ taskInfo.currency+' ' }}{{taskInfo.amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              消费税
            </el-col>
            <el-col :span="12" class="text-right">
              {{ taskInfo.currency+' ' }}{{taskInfo.tax_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              商家运费
            </el-col>
            <el-col :span="12" class="text-right">
              {{ taskInfo.currency+' ' }}{{taskInfo.transport_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line" v-if="taskInfo.other_amount && taskInfo.other_amount!='0.00'">
            <el-col :span="12">
              其他费用
            </el-col>
            <el-col :span="12" class="text-right">
              {{ taskInfo.currency+' ' }}{{taskInfo.other_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              商家小计
            </el-col>
            <el-col :span="12" class="text-right">
              {{ taskInfo.currency+' ' }}{{taskInfo.subtotal_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              <span>服务费</span>
            </el-col>
            <el-col :span="12" class="text-right">
              {{ taskInfo.currency }}{{taskInfo.service_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line" v-if="taskInfo.support_transport_service === '2'">
            <el-col :span="12">
              <span >国际运费</span>
            </el-col>
            <el-col :span="12" class="text-right">
              CNY {{ taskInfo.conditions.package_forwarding_fee | currency('¥') }}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              <span>实时汇率</span>
            </el-col>
            <el-col :span="12" class="text-right">
              {{taskInfo.currency_rate}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              <span >任务总计</span>
            </el-col>
            <el-col :span="12" class="text-right">
              CNY {{taskInfo.rmb_total_amount | currency('¥')}}
            </el-col>
          </el-row>
        </div>
        <el-button :disabled="Number(taskInfo.rmb_total_amount) <= 0" class="block" type="info" @click="taskInfoSubmit()">确定</el-button>
      </div>
    </div>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <h3 class="text-center">修改金额</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="(error,index) in errors" :key="index">{{error[0].message}}</li>
        </ul>
        <el-form-item label="" prop="tax_amount">
          <YueDanIpt :reg="/^\d+\.?\d{0,2}$/" model="tax_amount" :object="form" placeholder="消费税" :append="taskInfo.currency"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="transport_amount">
          <YueDanIpt :reg="/^\d+\.?\d{0,2}$/" model="transport_amount" :object="form" placeholder="商家运费" :append="taskInfo.currency"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="other_amount">
          <YueDanIpt :reg="/^\d*\.?\d{0,2}$/" model="other_amount" :object="form" placeholder="其他费用" :append="taskInfo.currency"></YueDanIpt>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="block" type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="paymentDialogVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="paymentDialogVisible" width="90%">
      <PaymentTip v-on:close="closeOtherPaymentDialogVisible" :newWindow="newWindow" :orderId="orderId" :order="taskInfo" :orderNo="order_no" :type="taskInfo.payment_type_info.type"></PaymentTip>
    </el-dialog>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import {API_HOST} from '../../../services/constant.js'
import PaymentTip from '../../payment/PaymentTip'
let _ = require('lodash')

export default {
  name: 'OrderTotal',
  props: ['goodsList', 'groupList'],
  components: {
    YueDanIpt: YueDanIpt,
    PaymentTip: PaymentTip
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    var checkIsPrice = (rule, value, callback) => {
      if (value && (isNaN(value) || value < 0)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }

    return {
      isSubmit: false,
      newWindow: null,
      checkPaidStatusInterval: null,
      orderId: null,
      wechatDialogVisible: false,
      paymentDialogVisible: false,
      loading: false,
      dialogFormVisible: false,
      errors: null,
      isEmptyErrors: true,
      copyGoodsList: [],
      form: {
        tax_amount: 0,
        transport_amount: 0,
        other_amount: 0
      },
      // business: null,
      bussinessList: null,
      tax_amount: 0,
      transport_amount: 0,
      other_amount: 0,
      service_amount: 0,
      currency_rate: 0,
      amount: 0,
      total_amount: 0,
      currentBusiness: null,
      rules: {
        tax_amount: [
          { required: true, message: '消费税是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        transport_amount: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        other_amount: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ]
      },
      isSingle: false,
      order_no: null,
      isInit:true,
    }
  },
  async created () {
    this.currentBusiness = this.$route.query.business_name || this.taskInfo.business_name
    this.isSingle = this.$route.fullPath.indexOf('buyer') > -1
    api.getExchangeRates(this).then(res => {
      this.exchangeRates = res.body.result
      this.currentBusiness = this.$route.query.business_name || this.taskInfo.business_name
      this.isSingle = this.$route.fullPath.indexOf('buyer') > -1
      this.init()
    })
  },
  methods: {
    closeOtherPaymentDialogVisible: function () {
      this.paymentDialogVisible = false
    },
    init () {
      this.errors = null
      this.isEmptyErrors = true
      this.form = {
        tax_amount: this.taskInfo.tax_amount || 0,
        transport_amount: this.taskInfo.transport_amount || 0,
        other_amount: this.taskInfo.other_amount || 0
      }
      this.tax_amount = this.taskInfo.tax_amount || 0
      this.transport_amount = this.taskInfo.transport_amount || 0
      this.other_amount = this.taskInfo.other_amount || 0
      
      this.checkPaidStatus()
      this.checkPaidStatusInterval = setInterval(() => {
        this.checkPaidStatus()
      }, 2000)
    },
    submit () {
      this.tax_amount = this.form.tax_amount
      this.transport_amount = this.form.transport_amount
      this.other_amount = this.form.other_amount
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          this.taskInfo.transport_amount_charge_type=this.taskInfo.conditions.transport_amount_charge_type;
          this.taskInfo.package_forwarding_fee=this.taskInfo.conditions.package_forwarding_fee;
          this.taskInfo.tax_amount = this.tax_amount
          this.taskInfo.transport_amount = this.transport_amount
          this.taskInfo.other_amount = this.other_amount
          this.cal()
          this.$store.commit('updateTaskInfo', this.taskInfo)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    async taskInfoSubmit () {
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      let apiType = this.isSingle ? '_by_single' : '_by_buyer'
      if (this.taskInfo.id) {
        this.taskInfo.order_id = this.taskInfo.id
        apiType = 'update' + apiType
      } else {
        apiType = 'add' + apiType
      }
      if (this.taskInfo.payment_type_info.type != 2 && !this.isSingle) {
        this.newWindow = window
      }
      this.taskInfo.transport_amount_charge_type=this.taskInfo.conditions.transport_amount_charge_type;
      this.taskInfo.package_forwarding_fee=this.taskInfo.conditions.package_forwarding_fee;
      let res = await api.post(this, {
        path: 'order.php',
        data: this.taskInfo,
        loading: 'loading',
        api: apiType
      })

      if (this.taskInfo.id) {
        this.$store.commit('clearTaskInfo')
        this.$router.push({path: this.$localStorage.get('goBackOrderUrl')})
        return
      }

      if (this.isSingle) {
        this.$store.commit('clearTaskInfo')
        this.$localStorage.remove('addressName')
        this.$router.push({ path: '/Complete', query: {isSingle: this.isSingle, order_no: res.body.result.order_no}})
      } else {
        let id = res.body.result
        if (id) {
          this.isSubmit = false
          if (this.taskInfo.payment_type_id == 0 || this.taskInfo.payment_type_info.type == 20) {
            this.$router.push({ path: '/Complete', query: {isSingle: this.isSingle, order_no: id.order_no}})
            this.$store.commit('clearTaskInfo')
            return
          }
          this.$router.push({ path: '/publish_task/confirm', query: {pay_order_id: id.id}})
          this.orderId = id.id
          this.paymentDialogVisible = true
          this.order_no = id.order_no
        }
      }
    },
    async checkPaidStatus () {
      let pay_order_id = this.$route.query.pay_order_id
      if (!pay_order_id) {
        return
      }
      try {
        let { body } = await api.checkPaidStatus(this, {
          order_id: pay_order_id,
          login_dialog: true
        })
        this.payState = body.result || 0

        if (this.payState != 0) {
          clearInterval(this.checkPaidStatusInterval)
          if (this.$route.path == '/customer/task/list') {
            this.$store.commit('clearTaskInfo')
            this.$router.go(0)
          } else {
            this.$store.commit('clearTaskInfo')
            this.$router.push({ path: '/Complete', query: {order_id: pay_order_id} })
          }
        }
      } catch (e) {

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.total-line {
  color: #686B73;
  line-height: 22px;
}
.total-sum {
  padding: 10px 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #DEE2EC;

  .amount {
    font-size: 24px;
    line-height: 33px;
  }
}

.empty-tip {
  color: #686B73;
  padding: 10px 0 25px;
  margin-bottom: 20px;
  border-bottom: 2px solid #DEE2EC;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/OrderTotalConfirm.vue